import React, { useState, useEffect } from 'react';
import './Header.css';
import { GrCertificate } from "react-icons/gr";
import { Link } from 'react-router-dom'
import Mobilenavbar from '../Pages/Mobilenavbar';
const Header = () => {
    const [isSticky, setSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setSticky(true);
            } else {
                setSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (


        <div>
            <header className={isSticky ? 'sticky' : ''} >
                <div class="header-top">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-5 col-sm-12 right_info">
                                <div>
                                    <div class="upper-column info-box">
                                        <div class="icon-box responsive_cerficate_icon" style={{ color: "white", marginBottom: "-45px", fontSize: "30px" }}><GrCertificate /></div>
                                        <ul className='responsive_cerficate_company'>
                                            <li><strong style={{ color: "white" }}>Certified Company</strong></li>
                                            <li style={{ color: "white" }}>ISO 9001:2015</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-7 col-sm-12 left_info" style={{ marginTop: "10px" }}>
                                <ul>
                                    <li><i class="fa fa-mobile-alt"></i><a href="#">+91 9980411999 | +91 ⁠9845164986</a></li>
                                    <li><i class="fa fa-envelope" aria-hidden="true"></i><a href="mailto:autometengg2@gmail.com">autometengg2@gmail.com</a></li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
<Mobilenavbar />
                <div class="header-main" style={{ height: "68px" }}>

                    <div class="container" style={{ marginRight: "20px" }}>

                        <nav id='cssmenu'>
                            <div className="logo">
                                <Link to="/">
                                    <img src="./Images/Logo.png" alt="Logo" />
                                </Link>
                            </div>

                            <ul>
                                <li className='active'><Link to='/'>HOME</Link></li>
                                <li>
                                    <Link to='/product'>PRODUCTS</Link>
                                    <ul>
                                        <li ><Link style={{ fontSize: "16px" }} to='/PerforatedSheets'>Perforated Sheets</Link></li>
                                        <li><Link style={{ fontSize: "16px" }} to='/PressComponents'>Press Components</Link></li>
                                        <li><Link style={{ fontSize: "16px" }} to='/FuelStrainers'>Fuel Strainers</Link></li>
                                        <li><Link style={{ fontSize: "16px" }} to='/SpotWelding'>Spot Welding</Link></li>
                                    </ul>
                                </li>
                                <li><Link to='/about'>ABOUT</Link></li>
                                <li><Link to='/gallery'>GALLERY</Link></li>
                                <li><Link to='/contact'>CONTACT</Link></li>
                                <div className="" style={{ marginLeft: "620px", marginTop: "-10px" }}>
                                    <Link
                                        to="/contact"
                                        className="btBtn btBtn btnFilledStyle btnAccentColor btnMedium btnNormalWidth btnRightPosition btnNoIcon"
                                    >
                                        <span className="btnInnerText" style={{ fontSize: "19px" }}>Get a Quote</span>
                                    </Link>
                                </div>
                            </ul>
                        </nav>
                        <Link to="/">
                            <img className='responsive_log_desktop' src="./Images/Logo.png" alt="Logo" />
                        </Link>
                    </div>

                </div>

            </header >

        </div >
    )
}

export default Header
